// Shared hover state for web. Replaces the copy-pasted
// `useState(hover)` + onMouseEnter/Leave boilerplate in every card/row/button.
// On native the handlers are inert (no pointer), so `hovered` stays false.
//
// Usage:
//   const { hovered, hoverProps } = useHover();
//   <Pressable {...hoverProps} style={[base, hovered && hoverStyle]} />

import { useMemo, useState } from 'react';
import { isWeb } from '../utils/web';

export interface HoverProps {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export interface UseHover {
  hovered: boolean;
  hoverProps: HoverProps;
}

export function useHover(): UseHover {
  const [hovered, setHovered] = useState(false);
  const hoverProps = useMemo<HoverProps>(
    () => (isWeb ? { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) } : {}),
    [],
  );
  return { hovered, hoverProps };
}
